module.exports = __webpack_public_path__ + "img/job-list.bbc67f83.png";